<!-- TEMPLATE -->
<template>
  <div class="dean-section-title">
    <span v-if="showTitle" :class="deanSectionTitleClass">
      <span class="dean-section-title-container">
        <span
          v-if="mobileButton || sidemenuButton"
          class="dean-section-title-sidemenu-button"
        >
          <slot name="sidemenu-button"></slot>
          <slot name="mobile-button"></slot>
        </span>
        <p lang="en"
          class="dean-section-title-text">
          <slot name="title"></slot>
        </p>
      </span>
      <span
        class="dean-section-title-buttons">
        <slot></slot>
      </span>
    </span>
    <span v-else :class="deanSectionTitleClass">
      <span
        class="dean-section-title-buttons">
        <slot v-if="sidemenuButton" name="sidemenu-button"></slot>
        <slot  v-if="mobileButton" name="mobile-button"></slot>
        <slot></slot>
      </span>
    </span>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

// COMPONENTS
@Component({})
export default class deanSectionTitle extends Vue {
  //PROPS
  @Prop() theme!: string;
  @Prop({ default: false }) secondary!: boolean;
  @Prop({ default: false }) sidebar!: boolean;
  @Prop({ default: false }) content!: boolean;
  @Prop({ default: false }) result!: boolean;
  @Prop({ default: false }) mobileButton!: boolean;
  @Prop({ default: false }) sidemenuButton!: boolean;
  @Prop({ default: true }) showTitle!: boolean;
  @Prop({ default: false }) alignLeft!: boolean;

  //COMPUTED
  get deanSectionTitleClass() {
    let value = 'dean-section-title-bar';
    if (this.sidebar) value += ` dean-section-title-bar-sidebar`;
    if (this.secondary) value += ` dean-section-title-bar-secondary`;
    if (this.content) value += ` dean-section-title-bar-content`;
    if (this.result) value += ` dean-section-title-bar-result`;
    if (this.alignLeft) value += ` dean-section-title-bar-align-left`;
    if (this.theme == 'themed') value += ` dean-section-title-bar-sidebar`;
    if (this.theme) {
      value += ` dean-section-title-bar-${this.theme}`;
    }
    return value;
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN SECTION TITLE
.dean-section-title {
  display: block;
  padding: 20px 10px 10px 10px;

  .dean-section-title-bar {
    display: flex;
    padding: 10px;
    justify-content: space-between;
    align-content: center;
    min-height: 50px;
    min-width: 100%;
    text-align: left;
    font-weight: 500;
    color: black;
    border: 1px solid transparant;
    @include border-radius(10px);

    .dean-section-title-text {
      display: flex;
      padding: 5px;
      padding-top: 1.5px;
      font-size: $font-heading-small;
      word-break: break-word;
      -webkit-hyphens: auto;
      -ms-hyphens: auto;
      -moz-hyphens: auto;
      hyphens: auto;
      width: 100%;
       // ELIPSES
      /*
        max-height: 50px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 100%;
        @media #{$small} {
          max-width: 150px;
        }
        @media #{$medium} {
          max-width: 158px;
        }
        @media #{$large} {
          max-width: 138px;
        }
        @media #{$hd} {
          max-width: 248px;
        }
      */
    }

    .dean-section-title-buttons {
      display: inline-flex;
      justify-content: flex-end;
      width: 100%;
    }
  }
  .dean-section-title-container {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }
  .dean-section-title-bar-sidebar {
    background: var(--color-light-shade-3, $color-light-shade-3);
    border: 1px solid var(--color-light, $color-light);
  }
  .dean-section-title-bar-secondary {
    border: 1px solid var(--color-light, $color-light);
  }
  .dean-section-title-bar-content {
    color: white;
    background: var(--color-primary, $color-primary);
    border: 1px solid var(--color-primary, $color-primary);
  }
  .dean-section-title-bar-result {
    color: white;
    background: var(--color-secondary, $color-secondary);
    border: 1px solid var(--color-secondary, $color-secondary);
  }
  .dean-section-title-bar-align-left {
    justify-content: flex-start;
  }
}
</style>
